import { render, staticRenderFns } from "./UpdateAudit.vue?vue&type=template&id=4f535818&scoped=true"
import script from "./UpdateAudit.vue?vue&type=script&lang=js"
export * from "./UpdateAudit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f535818",
  null
  
)

export default component.exports